import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';

type Props = {
    view: boolean;
}

const ManagePodcastDetail: React.FC<Props> = ({ view }: Props) => {
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.PODCAST}
            view={view}
            menu_name={'จัดการพอดแคสต์'}
            menu_name_detail='เพิ่มพอดแคสต์'
            menu_name_detail_edit='รายละเอียดพอดแคสต์'
            menu_path_name={routeName.e_library.manage_podcast}
        />
    )
}

export default ManagePodcastDetail